var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"header-logo",attrs:{"to":_vm.localePath('/')}},[_c('SfImage',{attrs:{"src":_vm.addBasePath('/icons/logo.svg'),"width":152,"height":48,"alt":"logo icon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }